import { devLog } from '@/utils'
import { promiseConfirm } from '@/utils/ui'

const _deviceEventWatcher = (eventName, checkHandler) => {
  let status = null
  let cpt = 0

  const handleDeviceMotionEvent = (e) => {
    status = checkHandler(e)
  }

  window.addEventListener(eventName, handleDeviceMotionEvent, true)
  return new Promise((resolve) => {
    const inter = setInterval(() => {
      if (status || cpt > 3) {
        clearInterval(inter)
        window.removeEventListener(eventName, handleDeviceMotionEvent, true)
        resolve(status === true)
      }
      cpt++
    }, 500)
  })
}

/**
 * @returns {Promise<Boolean>}
 */
const deviceEventsWatcherMotion = () => _deviceEventWatcher(
  'devicemotion',
  ({ acceleration }) => !!acceleration
)

/**
 * @returns {Promise<Boolean>}
 */
const deviceEventsWatcherOrientation = () => _deviceEventWatcher(
  'deviceorientation',
  ({
    beta,
    gamma
  } = {}) => typeof beta !== 'undefined' || typeof gamma !== 'undefined'
)

/**
 * Vérifie si nous avons bien accès a l'accéléromètre
 * @returns {Promise<Boolean>}
 */
export const requestDeviceEvents = async (isJustCheck = false) => {
  if (
    typeof DeviceMotionEvent === 'undefined' &&
    typeof DeviceOrientationEvent === 'undefined'
  ) {
    return true
  }

  const [statusDeviceOrientation, statusDeviceMotion] = await Promise.all([
    deviceEventsWatcherOrientation(),
    deviceEventsWatcherMotion()
  ])

  if (!statusDeviceOrientation || !statusDeviceMotion) {
    if (isJustCheck) {
      return false
    }

    try {
      await promiseConfirm(`Nous avons besoin de l'accéléromètre et du gyroscope pour faire fonctionner le PTI.`)
      await requestDeviceMotionPermissions()
      await requestDeviceOrientationPermissions()
      return requestDeviceEvents(true)
    } catch (e) {
      return false
    }
  }

  devLog('Accès au gyroscope.')
  devLog('Accès à l\'accéléromètre.')
  return true
}

const _requestEventPermission = async (event) => {
  if (
    typeof event !== 'undefined' &&
    typeof event.requestPermission === 'function'
  ) {
    const permissionsStatus = await event.requestPermission()
    return permissionsStatus === 'granted'
  }
  return false
}
/**
 * Demande la permission de récupérer les évènements du device motion (IOS 13)
 * @returns {Promise<boolean>}
 */
const requestDeviceMotionPermissions = () =>
  _requestEventPermission(window.DeviceMotionEvent)

/**
 * Demande la permission de récupérer les évènements du device orientation (IOS 13)
 * @returns {Promise<boolean>}
 */
const requestDeviceOrientationPermissions = () =>
  _requestEventPermission(window.DeviceOrientationEvent)
